import type { DashboardImgr } from "@caint/data";

/**
 * Cartão de cobertura/participação da unidade: respondido × esperado (da matriz).
 * Só aparece quando a unidade TEM matriz (esperadoTotal != null). Visível também
 * com 0 respostas — mostra o quadro esperado e quem ainda falta.
 */
export function CoberturaCard({ d }: { d: DashboardImgr }) {
  if (d.esperadoTotal == null) {
    return null;
  }
  const total = d.esperadoTotal;
  const participacao = total > 0 ? (d.nRespondentes / total) * 100 : 0;
  const cor = participacao >= 60 ? "var(--mat-3)" : participacao >= 30 ? "var(--warning)" : "var(--danger)";
  const faltando = [...d.coberturaCargos]
    .filter((c) => c.respondido < c.esperado)
    .sort((a, b) => b.esperado - b.respondido - (a.esperado - a.respondido))
    .slice(0, 12);

  return (
    <div className="m-card pad" style={{ marginBottom: 12 }}>
      <div style={{ fontSize: 12.5, fontWeight: 700, color: "var(--text-muted)", marginBottom: 10 }}>
        Cobertura · participação da unidade
      </div>

      <div style={{ display: "flex", justifyContent: "space-between", fontSize: 13, marginBottom: 4 }}>
        <span>
          <b>{d.nRespondentes}</b> de <b>{total}</b> respondentes esperados
        </span>
        <b style={{ color: cor, fontSize: 16 }}>{participacao.toFixed(0)}%</b>
      </div>
      <div style={{ height: 12, borderRadius: 99, background: "var(--surface-2)", overflow: "hidden" }}>
        <div
          style={{
            height: "100%",
            width: `${Math.min(100, participacao)}%`,
            background: cor,
            borderRadius: 99,
          }}
        />
      </div>

      <div style={{ fontSize: 12, fontWeight: 700, margin: "14px 0 4px" }}>
        Por área (respondido / esperado)
      </div>
      <div style={{ display: "grid", gap: 3 }}>
        {d.coberturaAreas.map((c) => {
          const resp = c.gestores + c.liderados;
          const esp = (c.esperadoGestor ?? 0) + (c.esperadoLiderado ?? 0);
          return (
            <div key={c.area} className="spec" style={{ display: "flex", justifyContent: "space-between" }}>
              <span>{c.area}</span>
              <b style={{ color: resp === 0 ? "var(--danger)" : undefined }}>
                {resp}/{esp}
              </b>
            </div>
          );
        })}
      </div>

      {faltando.length > 0 && (
        <>
          <div style={{ fontSize: 12, fontWeight: 700, margin: "14px 0 4px" }}>
            Cargos com lacuna (respondido / esperado)
          </div>
          <div style={{ display: "grid", gap: 2 }}>
            {faltando.map((c) => (
              <div
                key={c.cargo}
                className="spec"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <span
                  style={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    maxWidth: "72%",
                  }}
                >
                  {c.cargo}
                </span>
                <b style={{ color: c.respondido === 0 ? "var(--danger)" : "var(--warning)" }}>
                  {c.respondido}/{c.esperado}
                </b>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
